import { Download, X, Share, Smartphone } from "lucide-react";
import { useLang } from "../context/LanguageContext";

/* Bannière d'invitation à installer la PWA (présentiel — piloté par InstallContext). */
export const InstallBanner = ({ ios, hasNative, onInstall, onClose }) => {
  const { t } = useLang();

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed inset-x-0 bottom-0 z-[60] p-4 sm:bottom-4 sm:left-auto sm:right-4 sm:max-w-sm"
    >
      <div className="relative overflow-hidden rounded-2xl border border-cyan/30 bg-[#0a0e1a]/95 p-5 shadow-2xl backdrop-blur-xl">
        <div className="pointer-events-none absolute -right-10 -top-10 h-32 w-32 rounded-full bg-cyan/20 blur-3xl" />
        <button
          onClick={onClose}
          data-testid="pwa-install-dismiss"
          aria-label={t("pwa_later")}
          className="absolute right-3 top-3 text-ink-tertiary transition-colors hover:text-white"
        >
          <X size={18} />
        </button>
        <div className="relative flex items-start gap-4">
          <img src="/app-icon.png" alt="APP CHALLENGE ACADEMY" className="h-14 w-14 shrink-0 rounded-xl" />
          <div className="min-w-0">
            <h3 className="font-display text-base font-700 text-white">{t("pwa_title")}</h3>
            <p className="mt-1 text-sm leading-relaxed text-ink-secondary">{t("pwa_desc")}</p>
          </div>
        </div>

        {ios ? (
          <div className="relative mt-4 flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-xs text-ink-secondary" data-testid="pwa-install-ios-hint">
            <Share size={16} className="shrink-0 text-cyan" />
            <span>{t("pwa_ios_hint")}</span>
          </div>
        ) : hasNative ? (
          <div className="relative mt-4 flex gap-3">
            <button
              onClick={onInstall}
              data-testid="pwa-install-accept"
              className="inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-cyan px-5 py-3 text-sm font-600 uppercase tracking-wide text-void transition-all hover:glow-cyan"
            >
              <Download size={16} /> {t("pwa_install")}
            </button>
            <button
              onClick={onClose}
              data-testid="pwa-install-later"
              className="inline-flex items-center justify-center rounded-full border border-white/15 px-5 py-3 text-sm font-600 uppercase tracking-wide text-white transition-colors hover:border-white/40"
            >
              {t("pwa_later")}
            </button>
          </div>
        ) : (
          <div className="relative mt-4">
            <div className="flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-xs text-ink-secondary" data-testid="pwa-install-generic-hint">
              <Smartphone size={16} className="shrink-0 text-cyan" />
              <span>{t("pwa_generic_hint")}</span>
            </div>
            <button
              onClick={onClose}
              data-testid="pwa-install-later"
              className="mt-3 inline-flex w-full items-center justify-center rounded-full border border-white/15 px-5 py-3 text-sm font-600 uppercase tracking-wide text-white transition-colors hover:border-white/40"
            >
              {t("pwa_later")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
